export default {
    popupStyles: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    popupoOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 998,
    },

    popupChildrenStyles: {
        maxHeight: "unset",
        height: "100%",
        overflowY: "auto",
        display: "flex",
    },

    mainContainer: {
        width: "100%",
        padding: "0px 30px 30px",
        flex: "1 1 0%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    fieldsContainer: {
        padding: "20px",
        marginTop: "10px",
        WebkitBoxShadow: '0px 2px 8px 0px rgba(99, 99, 99, 0.2)',
        MozBoxShadow: '0px 2px 8px 0px rgba(99, 99, 99, 0.2)',
        boxShadow: '0px 2px 8px 0px rgba(99, 99, 99, 0.2)',
    },

    submitBtnDivStyles: {
        marginTop: "20px",
        textAlign: "center",
    },
    
    helpTextPopupStypes: {
        width: "80%", 
        maxWidth: "80%", 
        height: "80%"
    },
    helpTextPopupHeaderStyles: {
        border: "1px solid #ccc",
        padding: "5px 10px"
    },
    helpTextChildrenStyles: {
        padding: "20px",
        height: "100%",
    }
}